import LFCAutocomplete, {
  ChangeParameter,
  multiSelectData
} from '_components/inputs/LFCAutocomplete';
import {getLFCData} from '_logics/LFCUtil';
import axios, {CancelTokenSource} from 'axios';
import {useSnackbar} from 'notistack';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';

interface Props {
  name: string;
  label?: string;
  value: any;
  onChange: (relayDatas: ChangeParameter) => void;

  multiple?: boolean;
  style?: any;
  fullWidth?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  margin?: 'dense' | 'normal' | 'none';
  required?: boolean;
  size?: 'small' | 'medium';
}

/**
 * 検査装置プルダウン
 * @param props
 * @returns
 */
const LFCSelectFormDeviceEx = (props: Props) => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const cancelSource = useRef<CancelTokenSource | null>(null);

  const [items, setItems] = useState<{label: string}[]>([]);
  const [isAutoCompleteReset, setIsAutoCompleteReset] = useState<boolean>(false);

  useEffect(() => {
    cancelSource.current = axios.CancelToken.source();

    getLFCData({
      snack: enqueueSnackbar,
      sql_id: 40002,
      parameters: {},
      cancelToken: cancelSource.current.token,
      t
    }).then(ds => {
      const tmp: {label: string}[] = ds.map((item: {deviceid: string}) => {
        return {label: item['deviceid']};
      });
      setItems(tmp);
    });

    return () => {
      if (cancelSource.current) cancelSource.current.cancel('req cancel');
    };
  }, []);

  /**
   * 入力値変更
   */
  const onChange = useCallback((relayDatas: any) => {
    props.onChange(relayDatas);
  }, []);

  return (
    <LFCAutocomplete
      id={props.name}
      name={props.name}
      label={props.label || t('検査装置')}
      value={multiSelectData(items, props.value)}
      onChange={onChange}
      onReset={isAutoCompleteReset}
      doneReset={setIsAutoCompleteReset}
      multiple={props.multiple || false}
      selectItem={items}
      style={props.style}
      fullWidth={props.fullWidth}
      disabled={props.disabled}
      autoFocus={props.autoFocus}
      margin={props.margin}
      required={props.required}
      size={props.size}
    />
  );
};
export default LFCSelectFormDeviceEx;
